import PripomienkaDetail from '../../../../model/pripomienka/PripomienkaDetail';
import TypPripomienky from '../../../../model/pripomienka/TypPripomienky';
import SaveAdminPripomienka from '../../../../model/pripomienka/SaveAdminPripomienka';

export default (pripomienkaDetail: PripomienkaDetail): SaveAdminPripomienka => pripomienkaDetail && (
  {
    pripomienkujuciSubjekt: pripomienkaDetail.pripomienkujuciSubjekt,
    pripomienkovatel: pripomienkaDetail.pripomienkovatel,
    datumVytvorenia: pripomienkaDetail.datumPripomienkovania,
    clanok: '',
    paragraf: '',
    odsek: '',
    celyMaterial: false,
    ine: pripomienkaDetail.pripomienkaK,
    text: pripomienkaDetail.text,
    zasadna: pripomienkaDetail.typ === TypPripomienky.ZASADNA,
    odoslana: pripomienkaDetail.odoslana,
    povahaPripomienky: pripomienkaDetail.povahaPripomienky,
    priradeny: pripomienkaDetail.priradeny,
    vyhodnotil: pripomienkaDetail.vyhodnotil,
    stavPripomienky: pripomienkaDetail.stav,
    textVyhodnotenia: pripomienkaDetail.textVyhodnotenia,
  });
